
import GwInput from '~/patterns/atoms/input/input.vue';
import GwIcon from '~/patterns/atoms/icon/icon.vue';

export default {
    components: {
        GwInput,
        GwIcon
    },
    prop: ['value'],
    data() {
        return {
            query: this.value
        };
    },
    computed: {
        isSearching() {
            return this.query?.length > 0;
        }
    },
    methods: {
        handleInput() {
            this.$emit('input', this.query);
        },
        handleClear() {
            this.query = '';
            this.$emit('input', this.query);
        }
    }
};
